module.exports = __webpack_public_path__ + "img/rugby_jersey.89b685a6.jpg";